/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

const AudioMessage = ({ audioUrl }): JSX.Element => {
  return (
    <div className="audio-message">
      <div className="audio-player">
        <audio controls>
          <source src={audioUrl} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </div>
    </div>
  );
};

export default AudioMessage;
